import { useQuery } from '@tanstack/react-query'
import { racingPendingTicketsPollingQuery } from '@core/Data/Account/PendingTicketsCount/helpers/queries'

export const useCachedRacingPendingTicketsCount = ({ enabled }: { enabled: boolean }) => {
  const { data: pendingTicketsCount } = useQuery({
    ...racingPendingTicketsPollingQuery,
    enabled,
  })

  return pendingTicketsCount?.pendingTicketsCount ?? 0
}
